import React, { PureComponent } from 'react';
import { func, shape, oneOfType, arrayOf, string, object } from 'prop-types';
import { connect } from 'react-redux';
import {
  NotificationManager,
  NotificationContainer as ReactNotificationContainer,
} from 'react-notifications';
import { injectIntl } from 'react-intl';
import { clearNotifications } from '../actions/App';
import { NOTIFICATIONS_TYPE } from '../constants/Values';

class NotificationContainer extends PureComponent {
  static propTypes = {
    clearNotifications: func,
    intl: shape({
      messages: object,
      formatMessage: func,
    }),
    notifications: arrayOf(
      shape({
        message: oneOfType([string, arrayOf(string)]),
      }),
    ),
  };

  componentDidUpdate() {
    const notifications = this.props.notifications || [];
    const errorMessages = notifications.filter(msg => msg.type === NOTIFICATIONS_TYPE.ERROR);

    const totalErrorMessage = errorMessages.reduce(
      (previousValue, currentMsg) => {
        const errMsg =
          Object.keys(currentMsg).length > 0
            ? this.prepareNotificationMessage(currentMsg.message)
            : '';
        let messages = [];
        if (errMsg) {
          messages = [...previousValue.messages, errMsg];
        }
        return {
          options: { ...currentMsg.options },
          messages,
        };
      },
      { messages: [] },
    );

    if (totalErrorMessage && totalErrorMessage.messages && totalErrorMessage.messages.length) {
      NotificationManager.create({
        type: NOTIFICATIONS_TYPE.ERROR,
        ...totalErrorMessage.options,
        message: totalErrorMessage.messages.join('\n'),
      });
    }

    notifications.filter(msg => msg.type !== NOTIFICATIONS_TYPE.ERROR).forEach(notification => {
      NotificationManager.create({
        type: notification.type,
        ...notification.options,
        message: this.prepareNotificationMessage(notification.message),
      });
    });

    this.props.clearNotifications();
  }

  prepareNotificationMessage = message => {
    if (Array.isArray(message)) {
      return message.join('\n');
    }

    const { intl } = this.props;

    if (message in intl.messages) {
      return intl.formatMessage({ id: message });
    } else if (message instanceof Object) {
      return `${message.fieldName}: ${message.message}`;
    }

    return message || intl.formatMessage({ id: 'common.api.error' });
  };

  render() {
    return <ReactNotificationContainer />;
  }
}

export default injectIntl(
  connect(
    ({ app }) => ({ notifications: app.notifications }),
    { clearNotifications },
  )(NotificationContainer),
);
